import * as React from 'react';

import { Link } from '@cian/link-component';
import { mergeStyles } from '@cian/utils';

import { Description } from '../../offer-card/components/description';
import { parseHtmlEntities } from '../../utils/format';

import * as descriptionStyles from '../../offer-card/components/description/index.css';
import * as styles from './TopDescription.css';
/**
 * Блок описания для царь-карточки
 *
 * Отличия от базовой версии: вырезан заголовок объвлений, текст обрезается до 3-4 строк,
 * на узких разрешениях немного доработан перенос текста, добавлена кнопка "Подробнее"
 */
export class TopDescription extends Description {
  public render() {
    const { offer } = this.context;
    const {
      className,
    } = this.props;
    const parsedDescription = parseHtmlEntities(offer.description || '');

    const description = `${parsedDescription.slice(0, 185)}... `;

    if (!description) {
      return null;
    }

    let descriptionNodes: React.ReactNode[] = [];
    let currentPosition = 0;

    if (offer.descriptionWordsHighlighted && offer.descriptionWordsHighlighted.length > 0) {
      offer.descriptionWordsHighlighted.forEach(range => {
        descriptionNodes.push(
          description.substring(currentPosition, range[0]),
          <span key={range.toString()} className={descriptionStyles['label']}>
            {description.substring(range[0], range[1])}
          </span>,
        );
        currentPosition = range[1];
      });

      if (currentPosition < description.length) {
        descriptionNodes.push(description.substring(currentPosition));
      }
    } else {
      descriptionNodes.push(description);
    }

    return (
      <div {...mergeStyles(descriptionStyles['container'], styles['container'], className)}>
        { descriptionNodes }
        <span>
          <Link href={offer.fullUrl} target="_blank" onClick={this.handleMoreInfoClick}>
            Подробнее
          </Link>
        </span>
      </div>
    );
  }

  private handleMoreInfoClick = (e: React.MouseEvent<HTMLElement>) => {
    if (this.props.onPageJumped) {
      this.props.onPageJumped('card_more');
    }
    e.stopPropagation();
  }
}
